function browserLanguage(list) {
  const lang = navigator.language.slice(0, 2);
  return list.includes(lang) ? lang : list[0];
}

export default browserLanguage;
